namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeDaysColumns {
        static columnsKey = 'InitialData.PsDiscCouponTypeDays';
    }
}
